module.exports = __webpack_public_path__ + "static/media/attatchment.27fb86a8.svg";